/* eslint-disable import/prefer-default-export */

import { AxiosError } from "axios";
import { ERROR_CODE } from "src/constants/error";

export type AxiosErrorUnwrapType = {
  code: string;
  type?: string;
  nested?: Error;
  message?: string;
  response?: object;
};
type AuthErrorResponse = {
  timestamp: string;
  status: number;
  reason: string;
  messages: string[];
  data: object;
  path: string;
};

export type AxiosAuthErrorUnwrapType = {
  error?: AuthErrorResponse;
};

export type AxiosErrorType = AxiosErrorUnwrapType | AxiosAuthErrorUnwrapType;

/**
 * Type guard to check if the error is of type AxiosAuthErrorUnwrapType
 */
const isErrorFromAuth = (
  error: AxiosErrorType
): error is AxiosAuthErrorUnwrapType => {
  return (
    (error as AxiosAuthErrorUnwrapType)?.error !== undefined &&
    typeof (error as AxiosAuthErrorUnwrapType)?.error === "object"
  );
};

/**
 * unwrap axios error to get error data.
 * @param error input number;
 * @returns axios error response data.
 */
export const axiosErrorUnwrap = (
  error: AxiosError<AxiosErrorType>
): AxiosErrorUnwrapType => {
  // DEV-NOTE: (work around) the below condition is specific used to unwrap error from auth-service
  if (isErrorFromAuth(error?.response?.data)) {
    const message = error.response.data.error.messages[0];
    return {
      code: ERROR_CODE.TECHNICAL_ERROR,
      type: error.response.data.error.reason,
      message,
      response: {
        ...error.response,
        data: {
          ...error.response.data,
          error: {
            ...error.response.data.error,
            message,
          },
        },
      },
    };
  }

  // DEV-NOTE: the below condition is specific used to unwrap error from retail
  if (error?.response?.data?.code) {
    return {
      ...error.response.data,
      response: error.response,
    };
  }

  throw error;
};
